"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Slider_1 = require("@material-ui/core/Slider");
const TextField_1 = require("@material-ui/core/TextField");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const config_1 = require("../config/config");
const RewardDetailScreenStyle_1 = require("./jss/RewardDetailScreenStyle");
const RedeemQuantitySlider = ({ currentQuantity, onQuantityChange, maxRedeemAvailable, hideRedeemableQuantity, disableSlider, step, minQuantity, defaultQuantity, quantityLabel, color = 'secondary' }) => {
    const onQuantityChangeListener = (event) => {
        const integerQuantity = parseInt(event.target.value.replace(/\s/g, ''), 10);
        if (integerQuantity > maxRedeemAvailable) {
            setValue(maxRedeemAvailable);
            onQuantityChange(maxRedeemAvailable);
        }
        else if (integerQuantity >= 1 && integerQuantity <= maxRedeemAvailable) {
            setValue(integerQuantity);
            onQuantityChange(integerQuantity);
        }
        else {
            setValue('');
            onQuantityChange(1);
        }
    };
    const onBlur = (event) => {
        if (event.target.value === '') {
            setValue(1);
            onQuantityChange(1);
        }
    };
    const [value, setValue] = React.useState(defaultQuantity || 1);
    const handleSliderChange = (_, newValue) => {
        setValue(newValue);
        onQuantityChange(newValue);
    };
    const currentValue = value === '' ? defaultQuantity || 1 : Number(value);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TextField_1.default, { label: quantityLabel || 'Quantity', variant: config_1.config.internalConfig.FIELDS_VARIANT, fullWidth: true, value: value, margin: "normal", onChange: onQuantityChangeListener, onBlur: onBlur, inputProps: {
                    min: minQuantity || '1',
                    max: maxRedeemAvailable,
                    step,
                    id: quantityLabel || 'Quantity',
                    'aria-label': quantityLabel || 'Quantity',
                    autocomplete: 'off'
                }, helperText: !!currentQuantity && !hideRedeemableQuantity ? `Only ${currentQuantity} left ` : ``, disabled: !!disableSlider }), disableSlider ? null : ((0, jsx_runtime_1.jsx)(Slider_1.default, { value: currentValue, color: color, onChange: handleSliderChange, max: maxRedeemAvailable, min: minQuantity || 1, step: step, "aria-label": "Select quantity" }))] }));
};
exports.default = (0, styles_1.withStyles)(RewardDetailScreenStyle_1.default)(RedeemQuantitySlider);
//# sourceMappingURL=RedeemQuantitySlider.js.map